var map = {
	"./add.svg": "c2a3",
	"./batch.svg": "d4b9",
	"./card.svg": "2d9e",
	"./custom.svg": "d8c7",
	"./dataItem.svg": "53c0",
	"./equip.svg": "b1b0",
	"./equipment.svg": "b596",
	"./equipmentFaultLog.svg": "5911",
	"./index.svg": "abb8",
	"./menu.svg": "bd3d",
	"./money.svg": "3046",
	"./operateLog.svg": "162d",
	"./organization.svg": "e1a1",
	"./price.svg": "5a55",
	"./product.svg": "8d30",
	"./productEdit.svg": "d03c",
	"./productLog.svg": "e6cb",
	"./production.svg": "cdb4",
	"./report.svg": "9e5c",
	"./role.svg": "520c",
	"./salary.svg": "bf40",
	"./setting.svg": "05ff",
	"./shift.svg": "75f8",
	"./solid.svg": "4e6e",
	"./spec.svg": "38e7",
	"./staff.svg": "d46f",
	"./technology.svg": "1706",
	"./user.svg": "b3b5"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "51ff";